<h3>Commits to accept</h3>
<div class="container-fluid">
  <div class="row"> <!-- settings -->
    <div class="col-12">
      <div class="custom-control custom-checkbox custom-control-inline">
        <input name="displayOnlyNonAccepted" id="displayOnlyNonAccepted" type="checkbox" class="custom-control-input" value="displayOnlyNonAccepted" [(ngModel)]="displayOnlyNonAccepted" (ngModelChange)="onSettingChanged()">
        <label for="displayOnlyNonAccepted" class="custom-control-label">&nbsp;Display only non-accepted</label>
      </div>
      <div class="custom-control custom-checkbox custom-control-inline">
        <input name="autoAdvance" id="autoAdvance" type="checkbox" class="custom-control-input" value="displayOnlyNonAccepted" [(ngModel)]="autoAdvance">
        <label for="autoAdvance" class="custom-control-label">&nbsp;Auto-advance</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>url</th>
            <th>default branch</th>
            <th>total commits</th>
            <th>non-accepted commits</th>
          </tr>
        </thead>
        <tbody>
          @for (proj of getProjectView(); track proj.strapiProjectId) {
            <tr [class.table-info]="proj.strapiProjectId == selectedProject" (click)="select(proj)">
              <td [class.table-info]="proj.strapiProjectId == selectedProject">{{proj.strapiProjectId}}</td>
              <td [class.table-info]="proj.strapiProjectId == selectedProject"><a [href]="proj.url">{{proj.url}}</a></td>
              <td [class.table-info]="proj.strapiProjectId == selectedProject">{{proj.defaultBranch}}</td>
              <td [class.table-info]="proj.strapiProjectId == selectedProject">{{proj.totalCommits}}</td>
              <td [class.table-info]="proj.strapiProjectId == selectedProject">{{proj.nonAcceptedCommits}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-6">
      <table class="table table-sm table-hover">
        <thead>
          <tr (click)="toggleAllSelectedCommits()">
            <th>ID</th>
            <th>hash</th>
            <th>status</th>
            <th>author</th>
            <th>time committed - seen</th>
            <th>message</th>
          </tr>
        </thead>
        <tbody>
          @for (commit of commits; track commit.strapiId) {
            <tr (click)="toggleSelectedCommit(commit.strapiId)" [class.table-info]="selectedCommits.includes(commit.strapiId)">
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)">{{commit.strapiId}}</td>
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)"><a [href]="getCommitUrl(commit.hash)" target="_blank" (click)="$event.stopPropagation()">{{commit.hash}}</a></td>
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)">{{commit.acceptanceStatus}}</td>
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)">{{commit.author.name}} {{commit.author.email}}</td>
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)">{{commit.commitTime}}<br>{{commit.timeSeen}}</td>
              <td [class.table-info]="selectedCommits.includes(commit.strapiId)">{{commit.message}}</td>
            </tr>
          }
        </tbody>
      </table>

      <button type="button" class="btn btn-primary" (click)="setAccepted()">accept</button>
    </div>
  </div>
</div>

<hr>

<div class="d-flex align-items-center">
  <h3 (click)="showAdvancedOpenMrs = !showAdvancedOpenMrs" class="mb-0">{{getExpandIcon(showAdvancedOpenMrs)}} Open MRs advanced</h3>
  <button type="button" class="btn btn-outline-primary ms-3 d-flex align-items-center" [disabled]="refreshing" (click)="triggerRefresh()">
    @if (refreshing) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Refreshing...
    } @else {
      🔄 Refresh MRs
    }
  </button>
  <button type="button" class="btn btn-outline-secondary ms-2" (click)="selectAllMrs()">Select all</button>
  <button type="button" class="btn btn-outline-secondary ms-2" (click)="selectNoMrs()">Select none</button>
  <button type="button" class="btn btn-outline-success ms-2 d-flex align-items-center" [disabled]="merging || !selectedMrUrls.size" (click)="mergeSelectedMrs()">
    @if (merging) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Merging...
    } @else {
      Merge ({{selectedMrUrls.size}})
    }
  </button>
</div>

  @if (showAdvancedOpenMrs) {
    <div class="container-fluid">
      <div class="">
        <h4>Settings</h4>
        <select [(ngModel)]="selectedReason">
          <option [ngValue]="null">-</option>
          @for (reason of mergeRequestsAdvanced.openIgnoredWithReason; track reason.id) {
            <option [ngValue]="reason.id">
              {{reason.reason}}
            </option>
          }
        </select>
      </div>
      <div class="row">
        <h4 (click)="showCompletelyOpenMrs = !showCompletelyOpenMrs; showCompletelyOpenMrs ? loadAiActionCounts() : null">{{getExpandIcon(showCompletelyOpenMrs)}} Completely open (size {{mergeRequestsAdvanced.completelyOpen.length}})</h4>
        @if (showCompletelyOpenMrs) {
          <div class="col-12">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>URL</th>
                  <th>Title</th>
                  <th>Author</th>
                  <th>Approvals</th>
                  <th>Source</th>
                  <th>Destination</th>
                  <th>Changes</th>
                  <th>Open Discussions</th>
                  <th>AI Actions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (mr of mergeRequestsAdvanced.completelyOpen; track mr.mr.web_url; let i = $index) {
                  <tr [ngClass]="getClassesForMr(mr.mr)">
                    <td [ngClass]="getClassesForMr(mr.mr)"><input type="checkbox" class="form-check-input" [checked]="selectedMrUrls.has(mr.mr.web_url)" (click)="onMrCheckboxClick(i, $event)"></td>
                    <td [ngClass]="getClassesForMr(mr.mr)"><a [href]="mr.mr.web_url" target="_blank">{{mr.mr.web_url}}</a></td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{getFlags(mr.mr)}}{{mr.mr.title}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.author.name}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <ul>
                        @for (mrApprover of mr?.approval?.approved_by; track mrApprover.user.id) {
                          <li>{{mrApprover.user.name}}</li>
                        }
                      </ul>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.source_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.target_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.changes_count}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedDiscussionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandDiscussions(mr.mr.web_url)">
                        {{mr.mr.openDiscussions ?? '?'}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedAiActionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandAiActions(mr.mr.web_url)">
                        {{aiActionCounts[mr.mr.web_url] || 0}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" class="btn btn-sm btn-secondary" (click)="setActiveReason(mr.mr)">Set reason</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="setProjectNotMine(mr.mr, true)">Set project not mine</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiReview(mr.mr)">AI Review</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiMockFix(mr.mr)">AI Mock Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiFix(mr.mr)">AI Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiAnalyseFailure(mr.mr)">AI Analyse</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <h4 (click)="showOpenWithoutReason = !showOpenWithoutReason; showOpenWithoutReason ? loadAiActionCounts() : null">{{getExpandIcon(showOpenWithoutReason)}} Ignored without reason (size {{mergeRequestsAdvanced.openIgnoredWithoutReason.length}})</h4>
        @if (showOpenWithoutReason) {
          <div class="col-12">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>URL</th>
                  <th>Title</th>
                  <th>Author</th>
                  <th>Source</th>
                  <th>Destination</th>
                  <th>Changes</th>
                  <th>Open Discussions</th>
                  <th>AI Actions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (mr of mergeRequestsAdvanced.openIgnoredWithoutReason; track mr.mr.web_url) {
                  <tr [ngClass]="getClassesForMr(mr.mr)">
                    <td [ngClass]="getClassesForMr(mr.mr)"><a [href]="mr.mr.web_url" target="_blank">{{mr.mr.web_url}}</a></td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{getFlags(mr.mr)}}{{mr.mr.title}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.author.name}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.source_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.target_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.changes_count}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedDiscussionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandDiscussions(mr.mr.web_url)">
                        {{mr.mr.openDiscussions ?? '?'}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedAiActionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandAiActions(mr.mr.web_url)">
                        {{aiActionCounts[mr.mr.web_url] || 0}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" class="btn btn-sm btn-secondary" (click)="setActiveReason(mr.mr)">Set reason</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="unignore(mr.mr)">Unignore</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiReview(mr.mr)">AI Review</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiMockFix(mr.mr)">AI Mock Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiFix(mr.mr)">AI Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiAnalyseFailure(mr.mr)">AI Analyse</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <h4 (click)="showOpenWithReason = !showOpenWithReason">{{getExpandIcon(showOpenWithReason)}} Ignored with concrete reason ({{mergeRequestsAdvanced.openIgnoredWithReason.length}} reasons)</h4>
        @if (showOpenWithReason) {
          <div class="col-12">
            @for (reason of mergeRequestsAdvanced.openIgnoredWithReason; track reason.id) {
              <div>
                <h5 (click)="toggleShowReason(reason)">{{getExpandIcon(shownReasons.includes(reason.id))}} Reason: {{reason.reason}} (size {{reason.ignoredMrs.length}})</h5>
                @if (shownReasons.includes(reason.id)) {
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>URL</th>
                        <th>Title</th>
                        <th>Author</th>
                        <th>Source</th>
                        <th>Destination</th>
                        <th>Changes</th>
                        <th>Open Discussions</th>
                        <th>AI Actions</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (mr of reason.ignoredMrs; track mr.mr.web_url) {
                        <tr [ngClass]="getClassesForMr(mr.mr)">
                          <td [ngClass]="getClassesForMr(mr.mr)"><a [href]="mr.mr.web_url" target="_blank">{{mr.mr.web_url}}</a></td>
                          <td [ngClass]="getClassesForMr(mr.mr)">{{getFlags(mr.mr)}}{{mr.mr.title}}</td>
                          <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.author.name}}</td>
                          <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.source_branch}}</td>
                          <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.target_branch}}</td>
                          <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.changes_count}}</td>
                          <td [ngClass]="getClassesForMr(mr.mr)">
                            <button type="button" [ngClass]="expandedDiscussionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandDiscussions(mr.mr.web_url)">
                              {{mr.mr.openDiscussions ?? '?'}}
                            </button>
                          </td>
                          <td [ngClass]="getClassesForMr(mr.mr)">
                            <button type="button" [ngClass]="expandedAiActionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandAiActions(mr.mr.web_url)">
                              {{aiActionCounts[mr.mr.web_url] || 0}}
                            </button>
                          </td>
                          <td [ngClass]="getClassesForMr(mr.mr)">
                            <button type="button" class="btn btn-sm btn-secondary" (click)="setActiveReason(mr.mr)">Set reason</button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="unignore(mr.mr)">Unignore</button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiReview(mr.mr)">AI Review</button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiMockFix(mr.mr)">AI Mock Fix</button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiFix(mr.mr)">AI Fix</button>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiAnalyseFailure(mr.mr)">AI Analyse</button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>
            }
          </div>
        }
        <h4 (click)="showNotMine = !showNotMine; showNotMine ? loadAiActionCounts() : null">{{getExpandIcon(showNotMine)}} Not really mine (size {{mergeRequestsAdvanced.openButNotMine.length}})</h4>
        @if (showNotMine) {
          <div class="col-12">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>URL</th>
                  <th>Title</th>
                  <th>Author</th>
                  <th>Source</th>
                  <th>Destination</th>
                  <th>Changes</th>
                  <th>Open Discussions</th>
                  <th>AI Actions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (mr of mergeRequestsAdvanced.openButNotMine; track mr.mr.web_url) {
                  <tr [ngClass]="getClassesForMr(mr.mr)">
                    <td [ngClass]="getClassesForMr(mr.mr)"><a [href]="mr.mr.web_url" target="_blank">{{mr.mr.web_url}}</a></td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{getFlags(mr.mr)}}{{mr.mr.title}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.author.name}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.source_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.target_branch}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">{{mr.mr.changes_count}}</td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedDiscussionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandDiscussions(mr.mr.web_url)">
                        {{mr.mr.openDiscussions ?? '?'}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" [ngClass]="expandedAiActionsMrUrl === mr.mr.web_url ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-outline-secondary'" (click)="expandAiActions(mr.mr.web_url)">
                        {{aiActionCounts[mr.mr.web_url] || 0}}
                      </button>
                    </td>
                    <td [ngClass]="getClassesForMr(mr.mr)">
                      <button type="button" class="btn btn-sm btn-secondary" (click)="setActiveReason(mr.mr)">Set reason</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="setProjectNotMine(mr.mr, false)">Set project is mine</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiReview(mr.mr)">AI Review</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiMockFix(mr.mr)">AI Mock Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiFix(mr.mr)">AI Fix</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="triggerAiAnalyseFailure(mr.mr)">AI Analyse</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        <h4 (click)="showIgnoredButNoLongerOpen = !showIgnoredButNoLongerOpen">{{getExpandIcon(showIgnoredButNoLongerOpen)}} Ignored but no longer open (size {{mergeRequestsAdvanced.ignoredButNoLongerOpen.length}})</h4>
        @if (showIgnoredButNoLongerOpen) {
          <div class="col-12">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>URL</th>
                  <th>Reason</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (mr of mergeRequestsAdvanced.ignoredButNoLongerOpen; track mr.id) {
                  <tr>
                    <td>{{mr.id}}</td>
                    <td><a [href]="mr.url" target="_blank">{{mr.url}}</a></td>
                    <td>{{mr.reason}}</td>
                    <td>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="deleteObsoleteIgnore(mr)">Unignore</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button type="button" class="btn btn-sm btn-secondary" (click)="deleteAllObsolete()">Delete all obsolete</button>
          </div>
        }
        <h4 (click)="showMarkedAsNotMineButNoOpenMRs = !showMarkedAsNotMineButNoOpenMRs">{{getExpandIcon(showMarkedAsNotMineButNoOpenMRs)}} Marked as not mine but no open MRs (size {{mergeRequestsAdvanced.projectNotMineEntriesNotActuallyIgnoringAnything.length}})</h4>
        @if (showMarkedAsNotMineButNoOpenMRs) {
          <div class="col-12">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>URL Prefix</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (entry of mergeRequestsAdvanced.projectNotMineEntriesNotActuallyIgnoringAnything; track entry.id) {
                  <tr>
                    <td>{{entry.id}}</td>
                    <td>{{entry.urlPrefix}}</td>
                    <td>
                      <button type="button" class="btn btn-sm btn-danger" (click)="deleteProjectNotMine(entry.id)">delete</button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button type="button" class="btn btn-sm btn-secondary" (click)="deleteAllProjectNotMine()">Delete all obsolete</button>
          </div>
        }
      </div>
    </div>
    @if (expandedAiActionsMrUrl) {
      <div class="row mt-4">
        <div class="col-12">
          <h4>AI Actions for: {{expandedAiActionsMrUrl}}</h4>
          <app-qwen-command-list [commands]="expandedQwenCommands" (onDeleted)="onQwenCommandDeleted()"></app-qwen-command-list>
          <app-ai-command-list [commands]="expandedAiCommands" (onDeleted)="onAiCommandDeleted()"></app-ai-command-list>
        </div>
      </div>
    }
    @if (expandedDiscussionsMrUrl) {
      <div class="row mt-4">
        <div class="col-12">
          <h4>Open Discussions for: {{expandedDiscussionsMrUrl}}</h4>
          @if (expandedDiscussionThreads.length === 0) {
            <p>No open discussions.</p>
          } @else {
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Thread</th>
                  <th>File</th>
                  <th>Author</th>
                  <th>Created</th>
                  <th>Note</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                @for (thread of expandedDiscussionThreads; track thread.id; let threadIndex = $index) {
                  @for (note of thread.notes; track note.id) {
                    <tr>
                      <td>{{$first ? threadIndex + 1 : ''}}</td>
                      <td>{{getDiscussionNoteLocation(note)}}</td>
                      <td>{{note.author?.name}}</td>
                      <td>{{note.created_at | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                      <td class="discussion-note-body">{{note.body}}</td>
                      <td><a [href]="getDiscussionNoteLink(note)" target="_blank" rel="noopener">open</a></td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    }
  }
